import { getPositionFromIndex, createAnchor, getOverlappingAnchors, isAlreadyAnchored, isRejectedByLivePosition } from "../components/AutoSuggestion";
import { findCommandorNot, capitalizeInsideBraces, LineCommented, isCommented, isLineCommented, findTabularEnvs, parseColumnSpec, createGranularAnchors, numberToWords } from "../components/ReusableFunctions";
import { getInsideTextofBraces } from "../components/ReusableFunctions";
export const CeToolStyles = {
    ThousandSeparator: {
        name: "Thousand separator",
        description: "Add commas to numbers for thousands separation, skip 4-digit numbers",
        markerClass: "ace-Common-highlight",
        beforeImage: "/images/description/commaInNumberBefore.png",
        afterImage: "/images/description/commaInNumberAfter.png",

        execute(texFile, session, Range, anchorlist,
            fileName, Allfiles,
            existingSuggestions = [],
            rejectedSuggestions = []) {
            function getMathRanges(text) {
                const ranges = [];
                const mathEnvs = [
                    'equation', 'equation\\*', 'align', 'align\\*',
                    'alignat', 'alignat\\*', 'gather', 'gather\\*',
                    'multline', 'multline\\*', 'flalign', 'flalign\\*',
                    'eqnarray', 'eqnarray\\*', 'array', 'split',
                    'cases', 'dcases', 'math', 'displaymath'
                ];
                mathEnvs.forEach(env => {
                    const regex = new RegExp(`\\\\begin\\{${env}\\}[\\s\\S]*?\\\\end\\{${env}\\}`, 'g');
                    let m;
                    while ((m = regex.exec(text)) !== null) {
                        ranges.push([m.index, m.index + m[0].length]);
                    }
                });
                let m;
                const displayMath = /\\\[[\s\S]*?\\\]/g;
                while ((m = displayMath.exec(text)) !== null) ranges.push([m.index, m.index + m[0].length]);
                const inlineMath = /(?<!\$)\$(?!\$)[\s\S]*?(?<!\$)\$(?!\$)/g;
                while ((m = inlineMath.exec(text)) !== null) ranges.push([m.index, m.index + m[0].length]);
                const displayDollar = /\$\$[\s\S]*?\$\$/g;
                while ((m = displayDollar.exec(text)) !== null) ranges.push([m.index, m.index + m[0].length]);
                const inlineParen = /\\\([\s\S]*?\\\)/g;
                while ((m = inlineParen.exec(text)) !== null) ranges.push([m.index, m.index + m[0].length]);
                return ranges;
            }

            function isInsideMathRange(index, ranges) {
                return ranges.some(([start, end]) => index >= start && index < end);
            }

            const mathRanges = getMathRanges(texFile);
            const staleIds = new Set();
            const regex = /(?<![.,-])\b\d{4,}\b/g;
            let match;

            while ((match = regex.exec(texFile)) !== null) {
                const fullMatch = match[0];
                const suggestion = fullMatch.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                if (isInsideMathRange(match.index, mathRanges)) continue;

                const position = getPositionFromIndex(texFile, match.index, fullMatch.length);

                // ── Single reliable rejection check ──
                if (isRejectedByLivePosition(position, this.name, fullMatch)) continue;

                // Inside your execute loop in the style object:
                const overlapping = getOverlappingAnchors(position, this.name, existingSuggestions);
                if (overlapping.length > 0) {
                    overlapping.forEach(old => staleIds.add(old.id));
                } else {
                    if (isAlreadyAnchored(position, this.name, existingSuggestions)) continue;
                }

                if (!findCommandorNot(position.startRow, position.startCol, texFile)) {
                    createAnchor(session, Range, position, fullMatch, suggestion,
                        this.markerClass, this.name, this.description, anchorlist);
                }
            }

            return staleIds;
        }
    },
}